import React, { useEffect, useState } from "react";
import "./OurWork.css";
import InstagramEmbed from "../../components/InstagramEmbed";
import Testimonial from "../../components/Testimonial";
import { getOurWorkPhotos, getOurWorkVideos } from "../../services/galleryService";

const OurWork = () => {
  const [photos, setPhotos] = useState([]);
  const [videos, setVideos] = useState([]);
  const [visibleCount, setVisibleCount] = useState(8);
  const [popup, setPopup] = useState(null);

  useEffect(() => {
    getOurWorkPhotos().then(setPhotos);
    getOurWorkVideos().then(setVideos);
  }, []);

  const showMore = () => setVisibleCount(photos.length);

  const openPopup = (index) => setPopup(index);
  const closePopup = () => setPopup(null);
  const nextPhoto = () => setPopup((prev) => (prev + 1) % photos.length);
  const prevPhoto = () => setPopup((prev) => (prev - 1 + photos.length) % photos.length);

  return (
    <div className="our-work-page fade-in">
      <div className="page-header">
        <h1>Our Work</h1>
      </div>

      <section className="photo-gallery">
        <h2 className="slide-left">Photo Gallery</h2>
        <div className="photo-grid">
          {photos.slice(0, visibleCount).map((item, index) => (
            <div className="photo-card slide-up" key={index} onClick={() => openPopup(index)}>
              <img src={item.Image} alt={item.Title} />
              <p>{item.Title}</p>
            </div>
          ))}
        </div>
        {visibleCount < photos.length && (
          <button className="show-more" onClick={showMore}>Show More</button>
        )}
      </section>

      {popup !== null && (
        <div className="popup-overlay">
          <div className="popup-content">
            <button className="close-btn" onClick={closePopup}>&times;</button>
            <button className="nav-btn left" onClick={prevPhoto}>&#8592;</button>
            <img src={photos[popup].Image} alt={photos[popup].Title} />
            <p>{photos[popup].Title}</p>
            <button className="nav-btn right" onClick={nextPhoto}>&#8594;</button>
          </div>
        </div>
      )}

      <section className="video-gallery">
        <h2 className="slide-left">Watch Our Videos</h2>
        <div className="video-grid">
          {videos.map((video, index) => (
            <div className="video-card slide-up" key={index}>
              <iframe
                width="100%"
                height="215"
                src={video.Link.replace("watch?v=", "embed/")}
                title={`YouTube video ${index}`}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          ))}
        </div>
        <div className="youtube-btn">
          <a
            href="https://youtube.com/@shrijiagarwal?si=ABm8E-yorLkhHyPO" // Replace with actual channel
            target="_blank"
            rel="noopener noreferrer"
          >
            Watch more videos on our YouTube Channel
          </a>
        </div>
      </section>
      <section>
        <InstagramEmbed />
      </section>
      <Testimonial/>
    </div>
  );
};

export default OurWork;
